import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useAddMachineries = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const addNISmachineries = async (data) => {
    try {
      setLoading(true);
      try {
        const response = await axiosApi.post('/nisMachineries/insert', data);
        if (response && (response.status === 200 || response.status === 201)) {
          setSuccess('Data successfully added!');
          setError(null);
          return { success: true };
        }
        setError(response.data?.message || 'Failed to add data.');
        return { success: false };
      } catch (err) {
        setError(err.response?.data?.message || 'An error occurred while adding NIS data.');
        setSuccess(null);
        return { success: false };
      } finally {
        setLoading(false);
      }
    } catch (err) {
      setError('An error occurred while adding NIS data.');
      setSuccess(null);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return { loading, success, error, setSuccess, setError, addNISmachineries };
};


export default useAddMachineries;